import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=f446653c&scoped=true"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f446653c",
  null
  
)

export default component.exports